// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"320":"621ec7d6","453":"902a5192","597":"8b40d366","839":"f7636664"}[chunkId] + ".chunk.js";
};